import { useCallback, useState } from 'react';

import useBackend from '@/backend';
import { useAuthenticated, useRewardStoreActions } from '@/store';

export interface ReadMoreBonus {
	id: string;
	type: string;
	promotion_title: string;
	description: string;
	image_url: string;
	terms_and_conditions: string;
	valid_to: string;
	status: string;
	promo_bonus: {
		promo_code: string;
		promo_amount: string;
	};
	additional_bonus: {
		type: string;
		amount: string;
	} | null;
	deposit_bonus: any;
	games: any[];
}

const useGetRewards = () => {
	const { setOfferRewards, setClaimedRewards } = useRewardStoreActions();

	const { url_V3, getAccessToken } = useBackend();

	const [bonusDataById, setBonusDataById] = useState<ReadMoreBonus | null>(
		null
	);

	const getRewards = async () => {
		try {
			const headers: Record<string, string> = {
				'Content-Type': 'application/json',
			};
			const token = await getAccessToken({ v: 3 });
			if (token) headers['Authorization'] = token;

			const response = await fetch(
				token
					? `${url_V3}/bonus/offers?pageSize=30`
					: `${url_V3}/bonus?pageSize=30`,
				{ method: 'GET', headers }
			);

			const apiData = await response.json();
			if (apiData.success) {
				return apiData.data;
			}
		} catch (error) {}
	};

	const getClaimedRewards = async () => {
		try {
			const token = await getAccessToken({ v: 3 });
			const response = await fetch(`${url_V3}/bonus/claims`, {
				method: 'GET',
				headers: {
					Authorization: token,
					'Content-Type': 'application/json',
				},
			});
			const data = await response.json();
			if (data.success) {
				// setClaimedRewards(data.data);
				return data.data;
			}
		} catch (error) {}
	};

	const getBonusById = async (bonusId: string) => {
		try {
			const response = await fetch(`${url_V3}/bonus/${bonusId}`, {
				method: 'GET',
				headers: { 'Content-Type': 'application/json' },
			});
			const data = await response.json();
			if (data.success) {
				setBonusDataById(data.data?.bonus);
				return data.data?.bonus;
			}
			setBonusDataById(data);
		} catch (error) {}
	};

	const getUnclaimedBonuses = useCallback(async () => {
		const [rewardsResult, claimedResult] = await Promise.allSettled([
			getRewards(),
			getClaimedRewards(),
		]);

		if (
			rewardsResult.status !== 'fulfilled' ||
			claimedResult.status !== 'fulfilled'
		) {
			return [];
		}

		const allBonuses = rewardsResult.value.bonuses || [];

		const claimedBonusIds = new Set(
			(claimedResult?.value?.bonuses || []).map((b: any) => b.bonusId)
		);

		const filteredBonuses = allBonuses.filter(
			(bonus: any) => !claimedBonusIds.has(bonus.id)
		);
		// bonus.status === 'LIVE' &&

		setOfferRewards({
			featuredBonus: rewardsResult?.value?.featuredBonus || [],
			bonuses: filteredBonuses || null,
		});
		setClaimedRewards({
			bonuses: claimedResult?.value?.bonuses || [],
			claimed: claimedResult?.value?.claimed || 0,
		});
		// setOfferRewards(allBonuses);

		return allBonuses?.filter((bonus: any) => !claimedBonusIds.has(bonus.id));
	}, [getRewards, getClaimedRewards]);

	return {
		// getClaimedRewards,
		getBonusById,
		getUnclaimedBonuses,
		error: null,
		loading: false,
		bonusDataById,
	};
};

export default useGetRewards;
